import { Switch } from "@xola/ui-kit";
import { isExperienceProduct } from "common";
import React from "react";
import { canOverrideFutureCutoff } from "../../models/Experience";
import { useProduct } from "@/hooks/resources/useProduct";

interface OverrideFutureCutoffSwitchProps {
    productId: string;
    isChecked: boolean;
    onChange: () => void;
}

export const OverrideFutureCutoffSwitch = ({
    isChecked = false,
    onChange,
    productId,
}: OverrideFutureCutoffSwitchProps) => {
    const { data: product } = useProduct(productId);
    if (product && (!isExperienceProduct(product) || !canOverrideFutureCutoff(product))) {
        return null;
    }

    return (
        <div data-testid="override-future-cutoff-switch" className="p-5">
            <Switch.Group>
                <Switch isChecked={isChecked} size="medium" onChange={onChange} />
                <Switch.Label direction="right">Show future dates past cutoff</Switch.Label>
            </Switch.Group>
        </div>
    );
};
